import React from 'react';
import { toast } from 'react-toastify';

export function confirmToast(message, {
    okText = 'Sí, deshacer',
    cancelText = 'Cancelar',
    autoClose = false,
    position = 'top-right',
} = {}) {
    return new Promise((resolve) => {
        const id = toast(
            ({ closeToast }) => (
                <div style={{ minWidth: 280 }}>
                    <div style={{ marginBottom: 8, fontWeight: 600 }}>{message}</div>
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                        <button
                            onClick={() => { resolve(false); toast.dismiss(id); }}
                            className="btn btn-secondary"
                        >
                            {cancelText}
                        </button>
                        <button
                            onClick={() => { resolve(true); toast.dismiss(id); }}
                            className="btn btn-danger"
                        >
                            {okText}
                        </button>
                    </div>
                </div>
            ),
            {
                toastId: `confirm-${Date.now()}`,
                position,
                closeOnClick: false,
                draggable: false,
                autoClose,             // false → no se cierra solo
                hideProgressBar: true,
            }
        );
    });
}